export class ErrorHandlerService {
  constructor(globalAlert,) {
    this.globalAlert = globalAlert;
  }

  handle(error) {
    if (error.status) {
      return this.handleServerError(error);
    }
    console.error(error);
    let message = error.message || gettext('Неизвестная ошибка');
    if (message) {
      this.globalAlert(
        message,
        3000,
      );
    }
  }

  handleServerError({status, data}) {
    if (status === -1 || status === 502) {
      console.log(gettext(
        'Соединение с сервером было прервано. Перезагрузите страницу.'));
      return;
    }
    if (status === 422) {
      this.globalAlert(data, 3000);
      return;
    }
    console.error(data);
    this.globalAlert(
      gettext('Ошибка сервера ') + status +
      gettext(
        '. Попробуйте повторить последнюю операцию или перезагрузите страницу'),
      3000,
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/error-handler.service.js